import { render, staticRenderFns } from "./ProviderSearchResultCard.vue?vue&type=template&id=b80e5a42&scoped=true"
import script from "./ProviderSearchResultCard.vue?vue&type=script&lang=js"
export * from "./ProviderSearchResultCard.vue?vue&type=script&lang=js"
import style0 from "./ProviderSearchResultCard.vue?vue&type=style&index=0&id=b80e5a42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b80e5a42",
  null
  
)

export default component.exports